// Baku Gate Admin — AZ / EN / RU çevirmə sistemi
import { useSelector } from 'react-redux';

export const TRANSLATIONS = {
  az: {
    // Ümumi
    save: 'Saxla', cancel: 'Ləğv et', delete: 'Sil', edit: 'Redaktə', create: 'Yarat',
    loading: 'Yüklənir...', saving: 'Saxlanılır...', search: 'Axtar...',
    confirm_delete: 'Silmək istədiyinizə əminsiniz?', yes: 'Bəli', no: 'Xeyr',
    close: 'Bağla', back: 'Geri', next: 'İrəli', view: 'Bax', manage: 'İdarə et',
    total: 'Ümumi', active: 'Aktiv', inactive: 'Deaktiv', all: 'Hamısı',
    phone: 'Telefon', name: 'Ad Soyad', password: 'Şifrə', email: 'E-mail',
    notes: 'Qeyd', fin: 'FIN Kod', address: 'Ünvan', birthday: 'Doğum tarixi',
    gender: 'Cins', occupation: 'Peşə/İş', status: 'Status',
    male: 'Kişi', female: 'Qadın', other: 'Digər',
    // Nav
    nav_dashboard: 'Dashboard', nav_barriers: 'Şlaqbaumlar', nav_restaurants: 'Restoranlar',
    nav_users: 'İstifadəçilər', nav_wallet: 'Wallet', nav_analytics: 'Analitika',
    nav_settings: 'Parametrlər', nav_roles: 'Rollar',
    // Dashboard
    dash_title: 'Dashboard', dash_barriers_online: 'Online Şlaqbaumlar',
    dash_total_users: 'Ümumi İstifadəçi', dash_system: 'Sistem Statusu',
    dash_recent: 'Son Aktivlik',
    // Users
    users_title: 'İstifadəçi İdarəetməsi', users_sub: 'Sistem istifadəçiləri, işçilər və müştərilər',
    users_all: 'Hamısı', users_staff: 'İşçilər', users_clients: 'Müştərilər',
    users_create_staff: '+ Yeni İşçi', users_create_client: '+ Yeni Müştəri',
    users_edit: 'Redaktə', users_delete: 'Sil', users_block: 'Blokla', users_unblock: 'Bloku aç',
    users_details: 'Məlumatlar', users_wallet: 'Wallet', users_access: 'İcazə',
    users_perms: 'İcazə verilmiş modullar', users_barriers: 'Şlaqbaum girişi',
    users_barrier_add: 'Şlaqbauma əlavə et', users_role_change: 'Rol dəyiş',
    users_interests: 'Maraqlar', users_custom_role: 'Xüsusi Rol',
    users_last_login: 'Son giriş', users_reg_date: 'Qeydiyyat',
    users_not_found: 'İstifadəçi tapılmadı', users_count: 'nəfər',
    users_create_staff_btn: 'İşçi Yarat', users_create_client_btn: 'Müştəri Yarat',
    users_topup: 'Balans artır', users_topup_btn: 'Artır',
    users_recent_tx: 'Son əməliyyatlar', users_no_tx: 'Yoxdur',
    users_no_barriers: 'Heç bir şlaqbauma girişi yoxdur', users_verified: 'Doğrulanıb',
    users_staff_desc: 'İşçi admin panelinə giriş edə bilər. İcazələri aşağıda təyin edin.',
    users_client_desc: 'Ön qeydiyyat — App-dan həmin telefon ilə qeydiyyat keçdikdə avtomatik aktivləşir.',
    users_admin_note_ph: 'Daxili qeyd...',
    // Status
    status_active: 'Aktiv', status_inactive: 'Deaktiv', status_suspended: 'Dayandırılıb',
    status_vip: 'VIP', status_pending: 'Gözləyir', status_blocked: 'Bloklanıb',
    // Roles
    roles_title: 'Rol İdarəetməsi', roles_sub: 'Xüsusi rollar yarat, icazələri təyin et',
    roles_create: 'Yeni Rol Yarat', roles_name: 'Rol adı', roles_desc: 'Açıqlama',
    roles_perms: 'Funksiya İcazələri', roles_save: 'Rolu Saxla',
    // Settings
    settings_title: 'Sistem Parametrləri', settings_modules: 'Modul İdarəetməsi',
    settings_lang: 'Dil / Language', settings_theme: 'Görünüş',
    settings_save: 'Dəyişiklikləri Saxla',
    // Modules
    mod_barrier: 'Şlaqbaum', mod_restaurant: 'Restoran', mod_wallet: 'Wallet',
    mod_taxi: 'Taxi', mod_barber: 'Bərbər', mod_news: 'Xəbərlər',
    // Barriers
    bar_title: 'Şlaqbaum İdarəetməsi', bar_add: 'Yeni Şlaqbaum',
    bar_relay: 'Relay Test', bar_logs: 'Loglar', bar_users: 'İstifadəçilər',
    bar_online: 'Online', bar_offline: 'Offline',
    bar_devices: 'cihaz', bar_empty: 'Şlaqbaum yoxdur', bar_no_logs: 'Log yoxdur',
    bar_no_users: 'İstifadəçi yoxdur', bar_no_address: 'Ünvan göstərilməyib',
    bar_not_set: 'Qeyd edilməyib', bar_add_btn: 'Əlavə et', bar_optional: 'Opsional...',
    bar_remove: 'Çıxar', bar_copy: 'Kopyala', bar_copied: 'Kopyalandı',
    bar_select: 'Şlaqbaum seçin', bar_select_sub: 'və ya "+ Yeni" ilə əlavə edin',
    bar_select_hint: 'Şlaqbaum seçildikdən sonra buradan idarə edin',
    bar_closing: 'Bağlanır',
    bar_name: 'Ad', bar_ip: 'IP Ünvanı', bar_sim_phone: 'SIM Nömrəsi',
    bar_close_mode: 'Bağlanma rejimi', bar_close_timer: 'Taymerlə bağla', bar_close_sensor: 'Sensorla bağla',
    bar_open_duration: 'Açıq qalma (saniyə)',
    bar_servo_angle: 'Servo Bucaq', bar_servo_speed: 'Servo Sürəti',
    bar_open: 'Açıq', bar_closed: 'Bağlı', bar_instant: 'Ani',
    bar_battery: 'Batareya', bar_power: 'Elektrik',
    bar_power_ac: 'Şəbəkə', bar_power_bat: 'Batareya',
    bar_last_seen: 'Son aktiv', bar_created: 'Yaradılıb',
    bar_tab_logs: 'Loglar', bar_tab_users: 'İstifadəçilər', bar_tab_info: 'Məlumat',
    bar_tab_guestqr: 'Qonaq QR',
    bar_config: 'Konfiq', bar_edit_title: 'Redaktə et',
    bar_device_config: 'Cihaz Konfiqurasyonu',
    bar_no_guest_qr: 'Hələ qonaq QR yoxdur', bar_new_guest_qr: 'Yeni Qonaq QR Yarat',
    bar_guest_name: 'Qonaq adı (ixtiyari)', bar_guest_phone: 'Qonaq telefonu (ixtiyari)',
    bar_guest_max_uses: 'Maksimum istifadə (1-10)', bar_guest_expires: 'Müddət',
    bar_guest_note_ph: 'Mehman üçün...', bar_create_qr: 'QR Yarat',
    bar_hour: 'saat', bar_day: 'gün', bar_optional_short: 'ixtiyari', bar_uses: 'istifadə',
    // Restaurants
    rest_new: 'Yeni Restoran', rest_new_short: 'Yeni',
    rest_sub: 'Restoran, menyu və masa idarəsi',
    rest_list: 'Siyahı', rest_empty: 'Hələ restoran yoxdur',
    rest_first: 'İlk restoran yarat',
    rest_menu: 'Menyu', rest_tables: 'Masalar', rest_table: 'Masa',
    rest_name_ph: 'Restoran adı',
    rest_add_cat: 'Kateqoriya Əlavə Et', rest_cat_ph: 'Kateqoriya adı (Pizzalar, İçkilər...)',
    rest_add_item: 'Məhsul Əlavə Et', rest_add_item_btn: 'Məhsul əlavə et',
    rest_category: 'Kateqoriya', rest_select: 'Seçin',
    rest_price: 'Qiymət', rest_desc: 'Təsvir', rest_desc_ph: 'Qısa təsvir...',
    rest_no_cat: 'Hələ kateqoriya yoxdur', rest_no_items: 'Bu kateqoriyada məhsul yoxdur',
    rest_items: 'məhsul',
    rest_table_ph: 'Masa nömrəsi (1, A1, Terrace-3...)',
    rest_add_table: 'Masa əlavə et', rest_no_tables: 'Hələ masa yoxdur',
    rest_open_menu: 'Menyunu aç',
    // Auth
    logout: 'Çıxış',
    // Theme
    theme_dark: 'Gecə', theme_light: 'Gündüz', theme_glass: 'Şəffaf',
    // Announcements
    nav_announcements: 'Elanlar',
    ann_title: 'Elan İdarəetməsi', ann_new: 'Yeni Elan',
    ann_all: 'Hamısı', ann_general: 'Ümumi', ann_urgent: 'Təcili',
    ann_maintenance: 'Texniki', ann_event: 'Tədbir',
    // Delivery
    nav_delivery: 'Çatdırılma',
    del_title: 'Çatdırılma İdarəetməsi', del_new: 'Yeni Sifariş',
    del_status_pending: 'Gözlənilir', del_status_at_gate: 'Qapıdadır',
    del_status_delivered: 'Çatdırıldı', del_status_returned: 'Qaytarıldı',
    // Reports
    nav_reports: 'Hesabatlar',
    rep_title: 'Hesabatlar', rep_this_week: 'Bu həftə', rep_this_month: 'Bu ay',
    rep_3months: 'Son 3 ay', rep_custom: 'Xüsusi',
    rep_export_csv: 'CSV İxrac et', rep_export_json: 'JSON İxrac et',
    // Services / Health
    nav_services: 'Servislər',
    svc_title: 'Sistem Monitorinqi',
    svc_last_refresh: 'Son yenilənmə',
    svc_auto_refresh: 'Avtomatik yenilə',
    svc_refresh: 'Yenilə',
    svc_online: 'Online',
    svc_offline: 'Offline',
    svc_unknown: 'Naməlum',
    svc_uptime: 'Ayaqda olma müddəti',
    svc_response: 'Cavab vaxtı',
    svc_memory: 'Yaddaş',
    svc_version: 'Versiya',
    svc_last_check: 'Son yoxlama',
    svc_db: 'Verilənlər bazası',
    svc_all_online: 'Hamısı onlayn',
  },

  en: {
    save: 'Save', cancel: 'Cancel', delete: 'Delete', edit: 'Edit', create: 'Create',
    loading: 'Loading...', saving: 'Saving...', search: 'Search...',
    confirm_delete: 'Are you sure you want to delete?', yes: 'Yes', no: 'No',
    close: 'Close', back: 'Back', next: 'Next', view: 'View', manage: 'Manage',
    total: 'Total', active: 'Active', inactive: 'Inactive', all: 'All',
    phone: 'Phone', name: 'Full Name', password: 'Password', email: 'E-mail',
    notes: 'Notes', fin: 'FIN Code', address: 'Address', birthday: 'Birthday',
    gender: 'Gender', occupation: 'Occupation', status: 'Status',
    male: 'Male', female: 'Female', other: 'Other',
    nav_dashboard: 'Dashboard', nav_barriers: 'Barriers', nav_restaurants: 'Restaurants',
    nav_users: 'Users', nav_wallet: 'Wallet', nav_analytics: 'Analytics',
    nav_settings: 'Settings', nav_roles: 'Roles',
    dash_title: 'Dashboard', dash_barriers_online: 'Online Barriers',
    dash_total_users: 'Total Users', dash_system: 'System Status',
    dash_recent: 'Recent Activity',
    users_title: 'User Management', users_sub: 'System users, staff and clients',
    users_all: 'All', users_staff: 'Staff', users_clients: 'Clients',
    users_create_staff: '+ New Staff', users_create_client: '+ New Client',
    users_edit: 'Edit', users_delete: 'Delete', users_block: 'Block', users_unblock: 'Unblock',
    users_details: 'Details', users_wallet: 'Wallet', users_access: 'Access',
    users_perms: 'Allowed Modules', users_barriers: 'Barrier Access',
    users_barrier_add: 'Add to Barrier', users_role_change: 'Change Role',
    users_interests: 'Interests', users_custom_role: 'Custom Role',
    users_last_login: 'Last login', users_reg_date: 'Registered',
    users_not_found: 'No users found', users_count: 'users',
    users_create_staff_btn: 'Create Staff', users_create_client_btn: 'Create Client',
    users_topup: 'Top up balance', users_topup_btn: 'Add',
    users_recent_tx: 'Recent transactions', users_no_tx: 'None',
    users_no_barriers: 'No barrier access', users_verified: 'Verified',
    users_staff_desc: 'Staff can log into the admin panel. Set permissions below.',
    users_client_desc: 'Pre-registration — auto-activates when the user registers with this phone number.',
    users_admin_note_ph: 'Internal note...',
    status_active: 'Active', status_inactive: 'Inactive', status_suspended: 'Suspended',
    status_vip: 'VIP', status_pending: 'Pending', status_blocked: 'Blocked',
    roles_title: 'Role Management', roles_sub: 'Create custom roles, assign permissions',
    roles_create: 'Create New Role', roles_name: 'Role Name', roles_desc: 'Description',
    roles_perms: 'Feature Permissions', roles_save: 'Save Role',
    settings_title: 'System Settings', settings_modules: 'Module Management',
    settings_lang: 'Language', settings_theme: 'Appearance',
    settings_save: 'Save Changes',
    mod_barrier: 'Barrier', mod_restaurant: 'Restaurant', mod_wallet: 'Wallet',
    mod_taxi: 'Taxi', mod_barber: 'Barber', mod_news: 'News',
    bar_title: 'Barrier Management', bar_add: 'New Barrier',
    bar_relay: 'Relay Test', bar_logs: 'Logs', bar_users: 'Users',
    bar_online: 'Online', bar_offline: 'Offline',
    bar_devices: 'devices', bar_empty: 'No barriers found', bar_no_logs: 'No logs',
    bar_no_users: 'No users', bar_no_address: 'Address not set',
    bar_not_set: 'Not set', bar_add_btn: 'Add', bar_optional: 'Optional...',
    bar_remove: 'Remove', bar_copy: 'Copy', bar_copied: 'Copied',
    bar_select: 'Select a barrier', bar_select_sub: 'or add new with "+ New"',
    bar_select_hint: 'Select a barrier to manage it here',
    bar_closing: 'Closing',
    bar_name: 'Name', bar_ip: 'IP Address', bar_sim_phone: 'SIM Number',
    bar_close_mode: 'Close mode', bar_close_timer: 'Close by timer', bar_close_sensor: 'Close by sensor',
    bar_open_duration: 'Open duration (seconds)',
    bar_servo_angle: 'Servo Angle', bar_servo_speed: 'Servo Speed',
    bar_open: 'Open', bar_closed: 'Closed', bar_instant: 'Instant',
    bar_battery: 'Battery', bar_power: 'Power',
    bar_power_ac: 'AC Power', bar_power_bat: 'Battery',
    bar_last_seen: 'Last active', bar_created: 'Created',
    bar_tab_logs: 'Logs', bar_tab_users: 'Users', bar_tab_info: 'Info',
    bar_tab_guestqr: 'Guest QR',
    bar_config: 'Config', bar_edit_title: 'Edit',
    bar_device_config: 'Device Configuration',
    bar_no_guest_qr: 'No guest QRs yet', bar_new_guest_qr: 'Create New Guest QR',
    bar_guest_name: 'Guest name (optional)', bar_guest_phone: 'Guest phone (optional)',
    bar_guest_max_uses: 'Max uses (1-10)', bar_guest_expires: 'Duration',
    bar_guest_note_ph: 'For guest...', bar_create_qr: 'Create QR',
    bar_hour: 'hr', bar_day: 'day', bar_optional_short: 'optional', bar_uses: 'uses',
    // Restaurants
    rest_new: 'New Restaurant', rest_new_short: 'New',
    rest_sub: 'Restaurant, menu and table management',
    rest_list: 'List', rest_empty: 'No restaurants yet',
    rest_first: 'Create first restaurant',
    rest_menu: 'Menu', rest_tables: 'Tables',
    rest_name_ph: 'Restaurant name',
    rest_add_cat: 'Add Category', rest_cat_ph: 'Category name (Pizzas, Drinks...)',
    rest_add_item: 'Add Item', rest_add_item_btn: 'Add item',
    rest_category: 'Category', rest_select: 'Select',
    rest_price: 'Price', rest_desc: 'Description', rest_desc_ph: 'Short description...',
    rest_no_cat: 'No categories yet', rest_no_items: 'No items in this category',
    rest_items: 'items',
    rest_table: 'Table',
    rest_table_ph: 'Table number (1, A1, Terrace-3...)',
    rest_add_table: 'Add table', rest_no_tables: 'No tables yet',
    rest_open_menu: 'Open menu',
    logout: 'Logout',
    theme_dark: 'Dark', theme_light: 'Light', theme_glass: 'Glass',
    // Announcements
    nav_announcements: 'Announcements',
    ann_title: 'Announcement Management', ann_new: 'New Announcement',
    ann_all: 'All', ann_general: 'General', ann_urgent: 'Urgent',
    ann_maintenance: 'Maintenance', ann_event: 'Event',
    // Delivery
    nav_delivery: 'Delivery',
    del_title: 'Delivery Management', del_new: 'New Order',
    del_status_pending: 'Pending', del_status_at_gate: 'At Gate',
    del_status_delivered: 'Delivered', del_status_returned: 'Returned',
    // Reports
    nav_reports: 'Reports',
    rep_title: 'Reports', rep_this_week: 'This week', rep_this_month: 'This month',
    rep_3months: 'Last 3 months', rep_custom: 'Custom',
    rep_export_csv: 'Export CSV', rep_export_json: 'Export JSON',
    // Services / Health
    nav_services: 'Services',
    svc_title: 'System Monitoring',
    svc_last_refresh: 'Last refreshed',
    svc_auto_refresh: 'Auto refresh',
    svc_refresh: 'Refresh',
    svc_online: 'Online',
    svc_offline: 'Offline',
    svc_unknown: 'Unknown',
    svc_uptime: 'Uptime',
    svc_response: 'Response time',
    svc_memory: 'Memory',
    svc_version: 'Version',
    svc_last_check: 'Last check',
    svc_db: 'Database',
    svc_all_online: 'All online',
  },

  ru: {
    save: 'Сохранить', cancel: 'Отмена', delete: 'Удалить', edit: 'Редактировать', create: 'Создать',
    loading: 'Загрузка...', saving: 'Сохранение...', search: 'Поиск...',
    confirm_delete: 'Вы уверены, что хотите удалить?', yes: 'Да', no: 'Нет',
    close: 'Закрыть', back: 'Назад', next: 'Вперёд', view: 'Просмотр', manage: 'Управление',
    total: 'Всего', active: 'Активен', inactive: 'Неактивен', all: 'Все',
    phone: 'Телефон', name: 'ФИО', password: 'Пароль', email: 'E-mail',
    notes: 'Заметки', fin: 'ФИН-код', address: 'Адрес', birthday: 'Дата рождения',
    gender: 'Пол', occupation: 'Профессия', status: 'Статус',
    male: 'Мужской', female: 'Женский', other: 'Другой',
    nav_dashboard: 'Панель', nav_barriers: 'Шлагбаумы', nav_restaurants: 'Рестораны',
    nav_users: 'Пользователи', nav_wallet: 'Кошелёк', nav_analytics: 'Аналитика',
    nav_settings: 'Настройки', nav_roles: 'Роли',
    dash_title: 'Панель управления', dash_barriers_online: 'Онлайн шлагбаумы',
    dash_total_users: 'Всего пользователей', dash_system: 'Статус системы',
    dash_recent: 'Последняя активность',
    users_title: 'Управление пользователями', users_sub: 'Пользователи системы, сотрудники и клиенты',
    users_all: 'Все', users_staff: 'Сотрудники', users_clients: 'Клиенты',
    users_create_staff: '+ Новый сотрудник', users_create_client: '+ Новый клиент',
    users_edit: 'Редактировать', users_delete: 'Удалить', users_block: 'Заблокировать', users_unblock: 'Разблокировать',
    users_details: 'Сведения', users_wallet: 'Кошелёк', users_access: 'Доступ',
    users_perms: 'Разрешённые модули', users_barriers: 'Доступ к шлагбауму',
    users_barrier_add: 'Добавить к шлагбауму', users_role_change: 'Изменить роль',
    users_interests: 'Интересы', users_custom_role: 'Особая роль',
    users_last_login: 'Последний вход', users_reg_date: 'Дата регистрации',
    users_not_found: 'Пользователи не найдены', users_count: 'чел.',
    users_create_staff_btn: 'Создать сотрудника', users_create_client_btn: 'Создать клиента',
    users_topup: 'Пополнить баланс', users_topup_btn: 'Добавить',
    users_recent_tx: 'Последние транзакции', users_no_tx: 'Нет',
    users_no_barriers: 'Нет доступа к шлагбаумам', users_verified: 'Подтверждён',
    users_staff_desc: 'Сотрудник может войти в панель администратора. Настройте права ниже.',
    users_client_desc: 'Предварительная регистрация — активируется автоматически при регистрации с этим номером.',
    users_admin_note_ph: 'Внутренняя заметка...',
    status_active: 'Активен', status_inactive: 'Неактивен', status_suspended: 'Приостановлен',
    status_vip: 'VIP', status_pending: 'Ожидание', status_blocked: 'Заблокирован',
    roles_title: 'Управление ролями', roles_sub: 'Создавайте роли и назначайте права',
    roles_create: 'Создать роль', roles_name: 'Название роли', roles_desc: 'Описание',
    roles_perms: 'Права доступа', roles_save: 'Сохранить роль',
    settings_title: 'Системные настройки', settings_modules: 'Управление модулями',
    settings_lang: 'Язык', settings_theme: 'Оформление',
    settings_save: 'Сохранить изменения',
    mod_barrier: 'Шлагбаум', mod_restaurant: 'Ресторан', mod_wallet: 'Кошелёк',
    mod_taxi: 'Такси', mod_barber: 'Барбер', mod_news: 'Новости',
    bar_title: 'Управление шлагбаумами', bar_add: 'Новый шлагбаум',
    bar_relay: 'Тест реле', bar_logs: 'Журнал', bar_users: 'Пользователи',
    bar_online: 'Онлайн', bar_offline: 'Офлайн',
    bar_devices: 'устройств', bar_empty: 'Шлагбаумов нет', bar_no_logs: 'Журнал пуст',
    bar_no_users: 'Нет пользователей', bar_no_address: 'Адрес не указан',
    bar_not_set: 'Не указан', bar_add_btn: 'Добавить', bar_optional: 'Необязательно...',
    bar_remove: 'Удалить', bar_copy: 'Копировать', bar_copied: 'Скопировано',
    bar_select: 'Выберите шлагбаум', bar_select_sub: 'или добавьте новый через "+ Новый"',
    bar_select_hint: 'Выберите шлагбаум для управления',
    bar_closing: 'Закрывается',
    bar_name: 'Название', bar_ip: 'IP-адрес', bar_sim_phone: 'Номер SIM',
    bar_close_mode: 'Режим закрытия', bar_close_timer: 'Закрыть по таймеру', bar_close_sensor: 'Закрыть по датчику',
    bar_open_duration: 'Время открытия (сек)',
    bar_servo_angle: 'Угол серво', bar_servo_speed: 'Скорость серво',
    bar_open: 'Открыт', bar_closed: 'Закрыт', bar_instant: 'Мгновенно',
    bar_battery: 'Батарея', bar_power: 'Питание',
    bar_power_ac: 'Сеть', bar_power_bat: 'Батарея',
    bar_last_seen: 'Последняя активность', bar_created: 'Создан',
    bar_tab_logs: 'Журнал', bar_tab_users: 'Пользователи', bar_tab_info: 'Информация',
    bar_tab_guestqr: 'Гостевой QR',
    bar_config: 'Конфиг', bar_edit_title: 'Редактировать',
    bar_device_config: 'Конфигурация устройства',
    bar_no_guest_qr: 'Гостевых QR пока нет', bar_new_guest_qr: 'Создать гостевой QR',
    bar_guest_name: 'Имя гостя (необязательно)', bar_guest_phone: 'Телефон гостя (необязательно)',
    bar_guest_max_uses: 'Макс. использований (1-10)', bar_guest_expires: 'Срок',
    bar_guest_note_ph: 'Для гостя...', bar_create_qr: 'Создать QR',
    bar_hour: 'ч', bar_day: 'дн', bar_optional_short: 'необязательно', bar_uses: 'использ.',
    // Restaurants
    rest_new: 'Новый ресторан', rest_new_short: 'Новый',
    rest_sub: 'Управление ресторанами, меню и столами',
    rest_list: 'Список', rest_empty: 'Ресторанов пока нет',
    rest_first: 'Создать первый ресторан',
    rest_menu: 'Меню', rest_tables: 'Столы',
    rest_name_ph: 'Название ресторана',
    rest_add_cat: 'Добавить категорию', rest_cat_ph: 'Название категории (Пиццы, Напитки...)',
    rest_add_item: 'Добавить позицию', rest_add_item_btn: 'Добавить позицию',
    rest_category: 'Категория', rest_select: 'Выбрать',
    rest_price: 'Цена', rest_desc: 'Описание', rest_desc_ph: 'Краткое описание...',
    rest_no_cat: 'Категорий пока нет', rest_no_items: 'В этой категории нет позиций',
    rest_items: 'поз.',
    rest_table: 'Стол',
    rest_table_ph: 'Номер стола (1, A1, Terrace-3...)',
    rest_add_table: 'Добавить стол', rest_no_tables: 'Столов пока нет',
    rest_open_menu: 'Открыть меню',
    logout: 'Выход',
    theme_dark: 'Тёмная', theme_light: 'Светлая', theme_glass: 'Стекло',
    // Announcements
    nav_announcements: 'Объявления',
    ann_title: 'Управление объявлениями', ann_new: 'Новое объявление',
    ann_all: 'Все', ann_general: 'Общее', ann_urgent: 'Срочно',
    ann_maintenance: 'Техническое', ann_event: 'Событие',
    // Delivery
    nav_delivery: 'Доставка',
    del_title: 'Управление доставкой', del_new: 'Новый заказ',
    del_status_pending: 'Ожидание', del_status_at_gate: 'У ворот',
    del_status_delivered: 'Доставлено', del_status_returned: 'Возврат',
    // Reports
    nav_reports: 'Отчёты',
    rep_title: 'Отчёты', rep_this_week: 'На этой неделе', rep_this_month: 'В этом месяце',
    rep_3months: 'Последние 3 месяца', rep_custom: 'Произвольный',
    rep_export_csv: 'Экспорт CSV', rep_export_json: 'Экспорт JSON',
    // Services / Health
    nav_services: 'Сервисы',
    svc_title: 'Мониторинг системы',
    svc_last_refresh: 'Последнее обновление',
    svc_auto_refresh: 'Автообновление',
    svc_refresh: 'Обновить',
    svc_online: 'Онлайн',
    svc_offline: 'Офлайн',
    svc_unknown: 'Неизвестно',
    svc_uptime: 'Время работы',
    svc_response: 'Время ответа',
    svc_memory: 'Память',
    svc_version: 'Версия',
    svc_last_check: 'Последняя проверка',
    svc_db: 'База данных',
    svc_all_online: 'Все онлайн',
  },
};

// Hook: t('key') qaytarır
export function useT() {
  const lang = useSelector(s => s.i18n?.lang || 'az');
  return (key) => TRANSLATIONS[lang]?.[key] ?? TRANSLATIONS.az[key] ?? key;
}

export default TRANSLATIONS;
